<template>
  <div class="comme">
    <div class="comme_radio_list" >
      <div v-for="(item,index) in info.options"  :key="index">
      <div
        v-if="item.optionId"
        class="radio_list_item"
        :class="{radio_list_item__active: activeIndex == item.optionId || valueId == item.optionId}"
        @click="changeCheckActive(item.optionId,item)"
      >
        <el-tooltip  effect="light" :content="item.optionExplain" placement="top-start">
            <span v-if="item.optionExplain && item.optionExplain != ''">{{ item.optionName }}</span>
        </el-tooltip>
        <span v-if="item.optionExplain == '' || !item.optionExplain">{{ item.optionName }}</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: null
    };
  },
    props: {
      info: {
          type: [Object,Array],
          default: ()=> {}
      },
      index: {
          type: [String,Number],
          default: null
      },
      valueId: {
        type: [String,Number,Array],
        default: null
      }
  },
  methods: {
    // 切换选择框状态
    changeCheckActive(id, item) {
      this.activeIndex = id;
      let obj = {
        index: this.index,
        fieIdValue: item.optionName,
        optionId: [item.optionId],
        fieIdId: this.info.fieIdId,
        options: this.info.options,
        valueId: item.optionId,
        value: item.unitPrice,
      };
      this.$emit("changebox", obj);
    }
  }
};
</script>